<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Gudang'">
          <template v-slot:body>
            <Form
              :form="form"
              purpose="add"
              :route="'warehouses'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/warehouses/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: '',
        address: '',
        description: ''
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Gudang", route: "/masters/warehouses/list" },
      { title: "Daftar Gudang", route: "/masters/warehouses/list" },
      { title: "Tambah" },
    ])
  },

}

</script>